module.exports = __webpack_public_path__ + "img/icon-back.bd8b4615.svg";